
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAirGap as ObiAirGapElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-air-gap.js';
 
 
 

 
 export const ObiAirGap = createComponent({
   react: React,
   tagName: 'obi-air-gap',
   elementClass: ObiAirGapElement,
   events: {
     
   }
  });
 
 